<template>
  <div class="page-wrapper">
    <Tabs  v-model="current" :animated="false">
      <TabPane name="1" label="入住人" v-if="p('checkinPersion/getList')">
        <c1></c1>
      </TabPane>
      <TabPane name="2" label="客户信息管理" v-if="p('customerInfo/getCustomerList')">
        <c2></c2>
      </TabPane>
      <TabPane name="3" label="客户回访管理" v-if="p('workbench/getPersonVisitLogList')">
        <c3></c3>
      </TabPane>
      <TabPane name="jkjc" label="健康情况监测" v-if="p('customer/health-monitoring/findByCondition')">
        <customer-health></customer-health>
      </TabPane>
<!--      <TabPane name="enterprise" label="企业客户" >-->
<!--        <enterprise></enterprise>-->
<!--      </TabPane>-->
    </Tabs>
  </div>
</template>

<script>
  import C1 from '@/views/occupancy/renterManage/index'
  import C2 from '@/views/business/infoManage/index'
  import C3 from '@/views/personvisitlog/manage/index'
  import customerHealth from '@/views/business/customerHealth/index'
  // import enterprise from '@/views/business/enterprise/index'

  import {mixin} from "../../mixin";


  export default {
    name:'customer',
    components:{
      C1,
      C2,
      C3,
      customerHealth,
      // enterprise
    } ,
    mixins:[mixin],
    data(){
      return {
        current:null
      }
    }

  }
</script>

<style scoped>

</style>
